import { useSelector } from 'react-redux';
import Banner from '../Banner';
import { RootState } from '../../../redux/store';
import { formatCurrency } from '../../../utils';
import { useTranslation } from 'react-i18next';

export default function SpotBanner() {
	const userAssetBalance = useSelector(
		(state: RootState) => state.user.userAssetBalances
	);
	const { t } = useTranslation();

	const usdtBalance = userAssetBalance?.find(
		(asset) => asset.assetSymbol === 'USDT' && asset.chain === 'SPOT'
	);
	const actions = [
		'deposit',
		'withdraw',
		'transfer',
		'trade-history',
	] as BannerAction[];

	const valuation = {
		balance: formatCurrency(usdtBalance?.totalAssetAmount),
		currency: 'USDT',
	} as Valuation;

	return (
		<Banner
			title={'Spot Account'}
			valuation={valuation}
			// yesterdayPNL={'000 00'}
			actions={actions}
			isPayment
		/>
	);
}
